import { Component } from 'react';
import { connect } from 'react-redux';

import { checkDifferent } from 'utils/formHandlers';
import { formatCoordinate } from 'utils/formatCoordinate';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import { BackgroundType, CoordinateArray, RootState } from '../../types';

interface MousePositionProps {
    coordinate: CoordinateArray | null;
    openMenu?: boolean;
    openTool?: boolean;
    backgrounds: BackgroundType[];
}

interface MousePositionState {
    coordinate: [];
    openMenu?: boolean;
    openTool?: boolean;

    background: BackgroundType | null;
}

class MousePosition extends Component<MousePositionProps, MousePositionState> {
    constructor(props: MousePositionProps) {
        super(props);
        this.state = {
            background: null,
            coordinate: [],
            openMenu: props.openMenu,

            openTool: props.openTool,
        };
    }

    static getDerivedStateFromProps(props: MousePositionProps, state: MousePositionState) {
        if (
            checkDifferent(
                state.background,
                props.backgrounds.find((x) => {
                    return x.status === 'active';
                })
            )
        ) {
            return {
                background: props.backgrounds.find((x) => {
                    return x.status === 'active';
                }),
            };
        }

        if (
            checkDifferent(props.coordinate, state.coordinate) ||
            props.openMenu !== state.openMenu ||
            props.openTool !== state.openTool
        ) {
            return {
                coordinate: props.coordinate,

                openMenu: props.openMenu,
                openTool: props.openTool,
            };
        }

        return null;
    }

    render() {
        return (
            <div
                className={twclsx(
                    this.state.openMenu ? 'ml-menu' : this.state.openTool ? 'ml-28' : 'ml-14',
                    'flex',
                    'fixed',
                    'z-20',
                    'pl-2',
                    'margin-transition',
                    'left-0',
                    'gap-3',
                    'mb-1',
                    'bottom-0',
                    'text-sm',
                    this.state.background?.text === 'dark' ? 'text-black' : 'text-white'
                )}
            >
                <div className="w-44">
                    {this.state.coordinate
                        ? formatCoordinate(this.state.coordinate).join(' , ')
                        : `${translate('Move over the map')}`}
                </div>
            </div>
        );
    }
}

const mousePositionStateToProps = (state: RootState) => ({
    openMenu: state.layout.layout.openMenu,
    openTool: state.layout.layout.openTool,
});

const mousePositionDispatchToProps = () => ({});

export default connect(mousePositionStateToProps, mousePositionDispatchToProps)(MousePosition);
